<template>
  <div>
    <el-table
      v-if="inventory != null && inventoryTypes != null"
      :height="windowHeight - 250"
      :data="inventory"
      @row-click="openDialog"
    >
      <el-table-column
        label="Item"
        :fixed="$mq === 'xs' ? false : 'left'"
        sortable
        prop="item_name"
        min-width="150"
      ></el-table-column>
      <el-table-column label="Description" prop="item_description" min-width="200"></el-table-column>
      <el-table-column label="In-Stock" sortable prop="instock" align="center" min-width="100"></el-table-column>
      <el-table-column align="center" label="Total" prop="total" min-width="100"></el-table-column>
    </el-table>
    <div class="flex" style="margin-top: 16px; justify-content: end; align-items:end;">
      <el-button type="primary" @click="openDialog">New Item</el-button>
    </div>
    <el-dialog
      :title="reqL.o_id ? reqL.item_name : 'New Item'"
      :visible.sync="dialogVisible"
      @close="clearReq"
      width="60%"
      :fullscreen="$mq === 'xs'"
    >
      <el-form
        ref="form"
        :model="reqL"
        :rules="rules"
        v-loading="positions == null || inventory == null || inventoryTypes == null"
        :label-position="$mq === 'xs' ? 'top' : 'right'"
        label-width="160px"
      >
        <el-form-item label="Name">
          <el-input v-model="reqL.item_name"></el-input>
        </el-form-item>
        <el-form-item label="Description">
          <el-input type="textarea" v-model="reqL.item_description"></el-input>
        </el-form-item>
        <el-form-item label="Item Type">
          <el-select
            v-if="inventoryTypes != null"
            v-model="reqL.inventory_type_id"
            style="width: 100%"
            value-key="o_id"
            placeholder="Please select a type..."
          >
            <el-option
              v-for="position in inventoryTypes"
              :key="position.o_id"
              :label="position.name"
              :value="position.o_id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Requires Approval">
          <el-switch v-model="reqL.requires_approval" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
        <el-form-item label="Approval Position">
          <el-select
            v-if="positions != null"
            :disabled="!reqL.requires_approval"
            v-model="reqL.position_authority_id"
            style="width: 100%"
            value-key="o_id"
            placeholder="Please select a position"
          >
            <el-option
              v-for="position in positions"
              :key="position.o_id"
              :label="position.name"
              :value="position.o_id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="In Stock">
        <el-input-number v-model="reqL.instock" controls-position="right" :min="0" :max="reqL.total"></el-input-number>
        </el-form-item>
        <el-form-item label="Total">
        <el-input-number v-model="reqL.total" controls-position="right" :min="reqL.instock"></el-input-number>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveItem">{{reqL.o_id ? 'Save' : 'Create' }}</el-button>
          <el-button @click="closeDialog">Cancel</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

  </div>
</template>

<script>
import {mapFields} from "vuex-map-fields";

export default {
    props: ["selected_update"],
    mounted() {
        this.$store.dispatch("pullInventory");
        if (this.positions == null) this.$store.dispatch("pullPositions");
    },
    computed: {...mapFields(["user", "inventory", "positions", "inventoryTypes"])},
    data() {
        var checkAuthority = (rule, value, callback) => {
            if (this.reqL.requires_approval && value === null) {
                return callback(new Error("Please select position."));
            } 
            return callback();
      
        };
        return {
            dialogVisible: false,
            reqL: {
                item_name: null,
                inventory_type_id: null,
                item_description: "",
                requires_approval: false,
                position_authority_id: null,
                total: 0,
                instock: 0
            },
            rules: {
                item_name: [
                    {
                        required: true,
                        message: "Please input item name.",
                        trigger: "blur"
                    }
                ],
                inventory_type_id: [
                    {required: true, message: "Please select type.", trigger: "blur"}
                ],
                position_authority_id: [{validator: checkAuthority, trigger: "blur"}]
            }
        };
    },
    methods: {
        openDialog(row) {
            this.reqL = JSON.parse(JSON.stringify(row));
            this.dialogVisible = true;
        },
        closeDialog() {
            this.dialogVisible = false;
            this.clearReq();
        },
        clearReq() {
            this.reqL = {
                item_name: null,
                inventory_type_id: null,
                item_description: "",
                requires_approval: false,
                position_authority_id: null,
                total: 0,
                instock: 0
            };
        },
        saveItem() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    var item = JSON.parse(JSON.stringify(this.reqL));
                    if(!item.requires_approval){
                        this.$delete(item, 'position_authority_id');
                    }
                    if (item.o_id) {
                        //Update item
                        this.axios
                            .put("/api/v1/inventory/items/" + item.o_id, item, {
                                headers: {"Content-Type": "application/json"},
                                credentials: "same-origin"
                            })
                            .then((response) => {
                                this.inventory.splice(
                                    this.inventory.findIndex((e) => e.o_id == response.data.o_id),
                                    1,
                                    response.data
                                );
                                this.closeDialog();
                                this.$message({
                                    showClose: true,
                                    message: "Inventory item updated.",
                                    type: "success"
                                });
                            })
                            .catch((err) => {
                                this.$message({
                                    showClose: true,
                                    message: err.response.data.errors,
                                    type: "error"
                                });
                            });
                    } else {
                        //Create item
                        this.axios
                            .post("/api/v1/inventory/items", item, {
                                headers: {"Content-Type": "application/json"},
                                credentials: "same-origin"
                            })
                            .then((response) => {
                                this.inventory.unshift(response.data);
                                this.closeDialog();
                                this.$message({
                                    showClose: true,
                                    message: "Inventory item created.",
                                    type: "success"
                                });
                            })
                            .catch((err) => {
                                this.$message({
                                    showClose: true,
                                    message: err.response.data.errors,
                                    type: "error"
                                });
                            });
                    }
                } else {
                    return false;
                }
            });
        }
    }
};
</script>
